import { createAsyncAction, createAction } from 'typesafe-actions';


export const setBackUpLink = createAction('SET_BACKUP_LINK')<string>();